import { NavigationItem } from './libs';

export const getNavigationItemUrl = (item: NavigationItem) => {
  return item.routerUrl ? item.routerUrl : item.url ?? '';
};
